import React from 'react';

function DetailUser() {
  return <div>Detail User</div>;
}

export default DetailUser;
